import { Box, Flex, Heading } from '@modusign/design-system';

import Header from '@app/components/Header';
import LightHelpButton from '@app/components/HelpButton/LightHelpButton';
import ModusignIcon from '@app/components/Icons/ModusignIcon';
import useRedirect from '@app/features/fileHash/hooks/useRedirect';
import { getReferrer } from '@app/libs/referrer/getReferrer';

import getRedirectionLink from '../../libs/getRedirectionLink';

export default function FileHashHeader() {
  const { redirect } = useRedirect();

  const handleLogoClick = () => {
    redirect(getRedirectionLink(getReferrer()));
  };

  return (
    <Header flexShrink={0}>
      <Flex alignItems="center" flex={['none', null, 1]} justifyContent="flex-start">
        <Box as="button" ml={7} my="auto" onClick={handleLogoClick}>
          <ModusignIcon />
        </Box>
      </Flex>
      <Flex alignItems="center" flex={1} justifyContent={['flex-start', null, 'center']}>
        <Heading
          as="h1"
          color="textNeutralLightest"
          fontSize={[1, null, 2]}
          fontWeight="medium"
          my="auto"
          px={2}
        >
          문서 검증센터
        </Heading>
      </Flex>
      <Flex alignItems="center" display={['none', null, 'flex']} flex={1} justifyContent="flex-end">
        <Box mx={7} my="auto">
          <LightHelpButton />
        </Box>
      </Flex>
    </Header>
  );
}
